module.exports = __webpack_public_path__ + "static/img/naturalCircle9h.76d2ed7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/naturalCircle9h.svg
// module id = /y86
// module chunks = 1